.siteIndex {
    min-width: 700px;
    height: 100%;
    width: 100%;
    background-color: #9acae4;
}
.siteIndex header {
    height: 25px;
    background-color: #51bb9d;
    border-bottom: 1px white solid;
}
.siteIndex .title {
    position: relative;
    margin: 50px auto 25px;
    width: 476px;
    height: 32px;
    background-image: url(assets/images/index_title.png);
}
.siteIndex .title span {
    display: none;
}
.siteIndex .notice {
    text-align: center;
    height: 50px;
}
.siteIndex .image {
    float: left;
    width: 50%;
    height: 500px;
    background: url(assets/images/index_image.png) no-repeat top right;
}
.siteIndex .links {
    float: right;
    width: 50%;
    height: 500px;
}
.siteIndex .degu a {
    background: url(assets/images/index_link_degu.png) no-repeat;
}
.siteIndex .jm a {
    background: url(assets/images/index_link_jm.png) no-repeat;
}
.siteIndex .marmoset a {
    background: url(assets/images/index_link_marmoset.png) no-repeat;
}
.siteIndex .links ul {
    margin: 130px 20px;
    list-style-type: none;
}
.siteIndex .links ul li {
    line-height: 50px;
}
.siteIndex .links ul li a {
    display: inline-block;
    height: 22px;
    width: 250px;
}
.siteIndex .links ul li span {
    display: none;
}
.siteIndex footer {
    color: yellow;
    font-weight: 500;
    text-align: center;
}
